import normalizeViewState from "views/logic/views/normalizeViewState";
import AddWidgetToDashboardTab from "views/logic/views/AddWidgetToDashboardTab";
import GetWidgetTitle from "views/logic/views/GetWidgetTitle";
import View from "./View";
import FindWidgetAndQueryIdInView from "./FindWidgetAndQueryIdInView";
import UpdateSearchForWidgets from "./UpdateSearchForWidgets";
const _removeWidgetTitle = (titlesMap, widgetId) => {
  const widgetTitles = titlesMap.get("widget");
  if (!widgetTitles) {
    return titlesMap;
  }
  const newWidgetTitles = widgetTitles.remove(widgetId);
  return titlesMap.set("widget", newWidgetTitles);
};
const _removeWidgetFromTab = (widgetId, queryId, dashboard) => {
  const viewState = dashboard.state.get(queryId);
  const widgetIndex = viewState.widgets.findIndex((widget) => widget.id === widgetId);
  const { widgetPositions, titles } = viewState;
  const newTitles = _removeWidgetTitle(titles, widgetId);
  delete widgetPositions[widgetId];
  const { widgetMapping } = viewState;
  const newWidgetMapping = widgetMapping.remove(widgetId);
  const newViewState = viewState.toBuilder().widgets(viewState.widgets.delete(widgetIndex)).widgetMapping(newWidgetMapping).titles(newTitles).widgetPositions(widgetPositions).build();
  return dashboard.toBuilder().state(dashboard.state.set(queryId, normalizeViewState(newViewState))).build();
};
const MoveWidgetToTab = (widgetId, targetQueryId, dashboard, copy = false) => {
  if (dashboard.type !== View.Type.Dashboard) {
    throw new Error(`Unexpected type ${dashboard.type} expected ${View.Type.Dashboard}`);
  }
  const match = FindWidgetAndQueryIdInView(widgetId, dashboard);
  if (match) {
    const [widget, queryId] = match;
    const widgetTitle = GetWidgetTitle(widgetId, queryId, dashboard);
    const { widgetPositions } = dashboard.state.get(queryId);
    const oldPosition = widgetPositions[widgetId];
    const tempDashboard = copy ? dashboard : _removeWidgetFromTab(widgetId, queryId, dashboard);
    const newWidget = copy ? widget.toBuilder().newId().build() : widget;
    return UpdateSearchForWidgets(
      AddWidgetToDashboardTab(newWidget, targetQueryId, tempDashboard, oldPosition, widgetTitle)
    );
  }
  return void 0;
};
export default MoveWidgetToTab;
